import styled from '@emotion/styled';
import Container from '@mui/material/Container';

export const StyledContainer = styled(Container)`
  position: relative;
  margin-top: 4rem;
` as typeof Container;
